import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DEMO_LINK } from "@/App";

const BookDemo = () => {
  return (
    <section className="relative py-24 md:py-32 bg-surface border-y border-line overflow-hidden" data-testid="book-demo-section">
      <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-terra/10 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl font-bold tracking-tighter text-cream leading-[1.05]">
            See it answer a call, <span className="text-terra">live.</span>
          </h2>
          <p className="mt-6 max-w-xl text-base sm:text-lg text-sand leading-relaxed">
            Book a free demo and hear exactly how OrderHalal.ai takes a real order and drops it
            into your POS.
          </p>
          <a
            href={DEMO_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="section-demo-button"
            className="group mt-10 inline-flex items-center gap-3 rounded-full bg-terra px-8 py-4 text-base font-semibold text-cream hover:bg-terra-hover transition-[background-color,transform] duration-300 hover:-translate-y-1"
          >
            Book a Free Demo
            <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default BookDemo;
